const isString = (v) => typeof v === 'string';
const trim = (v) => (isString(v) ? v.trim() : v);

export function lenBetween(value, min, max) {
    if (value == null) return false;
    const v = Array.isArray(value) ? value : String(value);
    const n = v.length;
    if (min != null && n < min) return false;
    if (max != null && n > max) return false;
    return true;
}

export function isIdOrRelation(val) {
    if (val == null) return false;
    if (typeof val === 'number') return Number.isFinite(val);
    if (typeof val === 'string') return trim(val) !== '';
    if (typeof val === 'object' && 'id' in val) {
        const id = val.id;
        return typeof id === 'number' ? Number.isFinite(id) : trim(String(id || '')) !== '';
    }
    return false;
}

export function isNonEmptyArrayOfIdOrRelation(arr) {
    if (!Array.isArray(arr) || arr.length === 0) return false;
    return arr.every(isIdOrRelation);
}

export function isEmpty (v) {
    return v == null || (typeof v === "string" && v.trim() === "");
}

export function isBoolean(v) {
    return typeof v === 'boolean';
}

export function isPositiveInt(v) {
    return Number.isInteger(v) && v >= 1;
}

export function isNonNegativeInt(v) {
    if (v == null || v === '') return false;
    const n = Number(v);
    return Number.isInteger(n) && n >= 0;
}

export function optionalLenBetween(value, min, max) {
    if (value == null || String(value).trim() === '') return true;
    return lenBetween(value, min, max);
}

export function isOptionalArrayOfIds(arr) {
    if (arr == null) return true;
    return Array.isArray(arr) && arr.every(isPositiveInt);
}

export function isCustomFields(arr) {
    if (arr == null) return true;
    return (
        Array.isArray(arr) &&
        arr.every(
            (f) =>
                f &&
                isString(f.label) &&
                isString(f.value) &&
                lenBetween(f.label.trim(), 1, 100) &&
                lenBetween(f.value.trim(), 1, 255)
        )
    );
}

export function isNumber(v) {
    return typeof v === 'number' && !isNaN(v);
}

export function isPositiveNumber(v) {
    return isNumber(v) && v >= 0;
}

export function isNumberInRange(v, min, max) {
    return isNumber(v) && v >= min && v <= max;
}

export function isDateString(v) {
    if (v == null) return true;
    if (typeof v !== 'string') return false;
    const date = new Date(v);
    return !isNaN(date.getTime());
}

export function isFile(v) {
    return v == null || (typeof v === 'object' && v !== null && 'file' in v);
}

export function isValidUrl(v)  {
    if (!v) return true;
    try { new URL(v.startsWith("http") ? v : `https://${v}`); return true; }
    catch { return false; }
}

export function isISO4217 (v) {
    if (v == null || String(v).trim() === "") return true;
    return /^[A-Z]{3}$/.test(String(v).trim());
}

const Validation = {
    lenBetween,
    isIdOrRelation,
    isNonEmptyArrayOfIdOrRelation,
    isEmpty,
    isBoolean,
    isPositiveInt,
    optionalLenBetween,
    isOptionalArrayOfIds,
    isISO4217,
    isCustomFields,
    isString,
    isPositiveNumber,
    isNonNegativeInt,
    isNumberInRange,
    isDateString,
    isFile,
    isValidUrl,
};
export default Validation;